import React, { useEffect, useState } from "react";
import { Col, Container, Form, Label, Row } from "reactstrap";
import "./aboutUs.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { imageUpload } from "../../services/BannersServices";
import { Constants } from "../../Constants";
import axios from "axios";
import { stateToHTML } from "draft-js-export-html";
import { stateFromHTML } from "draft-js-import-html";
import { toast, ToastContainer } from "react-toastify";
import { EditorState } from "draft-js";
import Loading from "../../components/loading/Loading";
import { fetchAboutUs, putAboutUs } from "../../services/SharedServices";
import ViewInWeb from "../../components/Common/ViewInWeb";
import { IconItem } from "./agent";

function AboutUs() {
  const [description, setDescription] = useState(EditorState.createEmpty());
  const [data1, setData1] = useState(EditorState.createEmpty());
  const [data2, setData2] = useState(EditorState.createEmpty());
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState("");
  const [icon1, setIcon1] = useState("");
  const [icon2, setIcon2] = useState("");

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchAboutUs({
        token: "",
      });
      let { description, data1, data2, image, icon1, icon2 } =
        response.data.data.config;
      setLoading(false);
      setDescription(EditorState.createWithContent(stateFromHTML(description)));
      setData1(EditorState.createWithContent(stateFromHTML(data1)));
      setData2(EditorState.createWithContent(stateFromHTML(data2)));
      setImage(image);
      setIcon1(icon1);
      setIcon2(icon2);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let response = await putAboutUs({
        token: "",
        description: stateToHTML(description.getCurrentContent()),
        data1: stateToHTML(data1.getCurrentContent()),
        data2: stateToHTML(data2.getCurrentContent()),
        image,
        icon1,
        icon2,
      });
      setLoading(false);
      toast(`Seccíon guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const uploadCallback = async (file: any) => {
    const result = {
      data: {
        link: "",
      },
    };
    try {
      var form = new FormData();
      form.append("file", file);
      let response = await imageUpload({
        form,
        token: "",
        type: "textEdition",
      });
      result.data.link = `${Constants.BASE_URL}${response.data.data.image}`;
    } catch (error: any) {
      console.log(error.response);
    }
    return result;
  };

  const handleAcceptedFiles = async (files: any, key: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "agent",
        });
        if (key === "image") {
          setImage(response.data.data.image);
        }
        if (key === "icon1") {
          setIcon1(response.data.data.image);
        }
        if (key === "icon2") {
          setIcon2(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Sobre nosotros" breadcrumbItem="Sobre nosotros" />
          <Row>
            <Col>
              <div className="row">
                <div className="col-12 col-md-12">
                  <Label>Descripción</Label>
                </div>
                <div className="col-12 col-md-8">
                  <Editor
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    toolbar={{
                      options: [
                        "inline",
                        "blockType",
                        "link",
                        "emoji",
                        "image",
                      ],
                      inline: { inDropdown: true },
                      link: { inDropdown: true },
                      image: { uploadCallback },
                    }}
                    editorState={description}
                    onEditorStateChange={(d: any) => setDescription(d)}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <IconItem
                    icon={image}
                    handleAcceptedFiles={handleAcceptedFiles}
                    iconKey="image"
                    ignoreLink={true}
                  />
                </div>
              </div>
              {/*<div className="row" style={{ marginTop: "2rem" }}>
                <div className="col-12 col-md-12">
                  <Label>Misión</Label>
                </div>
                <div className="col-12 col-md-8">
                  <Editor
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    toolbar={{
                      options: [
                        "inline",
                        "blockType",
                        "link",
                        "emoji",
                        "image",
                      ],
                      inline: { inDropdown: true },
                      link: { inDropdown: true },
                      image: { uploadCallback },
                    }}
                    editorState={data1}
                    onEditorStateChange={(d: any) => setData1(d)}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <IconItem
                    icon={icon1}
                    handleAcceptedFiles={handleAcceptedFiles}
                    iconKey="icon1"
                    ignoreLink={true}
                  />
                </div>
                <div className="col-12 col-md-12 mt-4">
                  <Label>Valores</Label>
                </div>
                <div className="col-12 col-md-8">
                  <Editor
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    toolbar={{
                      options: [
                        "inline",
                        "blockType",
                        "link",
                        "emoji",
                        "image",
                      ],
                      inline: { inDropdown: true },
                      link: { inDropdown: true },
                      image: { uploadCallback },
                    }}
                    editorState={data2}
                    onEditorStateChange={(d: any) => setData2(d)}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <IconItem
                    icon={icon2}
                    handleAcceptedFiles={handleAcceptedFiles}
                    iconKey="icon2"
                    ignoreLink={true}
                  />
                </div>
              </div>*/}
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link="https://mariomendez.uy/empresa" />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default AboutUs;
